/**
 * @module Section-Home2-Services
 */

import { NavLink } from "react-router-dom";
import { navUrl, publicUrlFor } from "../../../../globals/common-functions";
import { route } from "../../../../globals/constants";
import { TypeSectionServices } from "../../../@types/sectionTypes";
import AvertImage from "../../../../globals/elements/avertimg";
   import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
import { useRef } from "react";
gsap.registerPlugin(ScrollTrigger, SplitText);
/**
 * 
 * @param props : Data supplied to display services
 * @returns Markup for section containing different services
 */
const SectionHome2Services = (
    props: {
        _services: TypeSectionServices
    }
) => {
    const { _services } = props;
     const container = useRef<HTMLDivElement | null>(null);

  useGSAP(
    () => {
    //   let split = SplitText.create(".about_para_animation", {
    //     type: "lines",
    //   });
 
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
        //   markers: true
        },
      });
    //   tl.fromTo(
    //     ".reveal",
    //     { scale: 0.8, opacity: 0 },
    //     { scale: 1, duration: 1, opacity: 1 },
    //   )

tl.fromTo(
          ".service_card_animation",
          { opacity: 0, y: 80 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0.4"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
    return (
        <div className="section-full p-t120 p-b90 av-serv-1-section-wrap wow fadeInDown" data-wow-offset={100} data-wow-delay="0.2" style={{ backgroundImage: `url(${publicUrlFor("images/background/BG-2.jpg")})` }}>
            <div className="section-content">
                <div className="container" ref={container}>
                    <div className=" av-grid-slider swi-dotts">
                        <div className="swiper-wrapper">
                            {
                                _services.services.map((_item, _index) => {
                                    return (
                                        <div key={_index} className="swiper-slide service_card_animation">
                                            <div className="av-icon-style-2-blocks">
                                                <div className="av-media">
                                                    <span><AvertImage src={_item.icon} alt="icon" /></span>
                                                </div>
                                                <div className="av-content">
                                                    <h3 className="av-title"><NavLink to="/">{_item.title}</NavLink></h3>
                                                    { _item.count && <b>{_item.count!}</b> }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="swiper-pagination" />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SectionHome2Services;